import {
  SCENARIO__CREATE,
  SCENARIO__EDIT_IMPLEMENTED_PLAN,
  SCENARIO__IMPLEMENT,
  SCENARIO__REQUEST_REVIEW,
  SCENARIO__ARCHIVE,
  SCENARIO__DOWNLOAD_PDF,
  SCENARIO__SEND_PDF,
  SCENARIO__EXPORT_PROJECTIONS,

  ASSUMPTION__VIEW,
  ASSUMPTION__EDIT,

  ASSET_EVENT__ALL,

  JOINT_PLAN__CREATE,
  JOINT_PLAN__EDIT,
  JOINT_PLAN__VIEW,
  JOINT_PLAN__DELETE,
  JOINT_PLAN__DOWNLOAD_PDF,

  CUSTOMER_SUPPORT_TICKET__QUICK_REPORT_ISSUE,

  WEALTH_MANAGER_REQUEST__ALL,
  ASTUTE_CCP__ALL,
  FNA__ALL,
  MOMENTUM_POC__ALL,
  CLIENT_PDF_REPORT__ALL,
  CLIENT_LIABILITY__ALL,
  SCENARIO_IMPLEMENTED_PLAN_READ_ONLY__ALL,

  ASSET__AUTO_LINKING,

  NOTE__EDIT,
  NOTE__CREATE,
  NOTE__VIEW_PRIVATE,

  INVESTMENT_PROPOSAL__CREATE
} from './useFeatureConfig.constants'

/**
 * FeatureAccessProvider returns an object with a consistent interface from
 * which a client can determine whether a feature is enabled, using the method
 * `isEnabled`.
 */
export default function FeatureAccessProvider(hasPermissions, hasFeatureToggle) {
  return {
    isEnabled(featureName, _args = {}) {
      switch (featureName) {
        case SCENARIO__CREATE:
          return hasPermissions('scenario:create')

        case SCENARIO__EDIT_IMPLEMENTED_PLAN:
          return hasPermissions('scenario:edit-implemented-plan')

        case SCENARIO__IMPLEMENT:
          return hasPermissions('scenario:implement')

        case SCENARIO__REQUEST_REVIEW:
          return hasPermissions('scenario:request-review')

        case SCENARIO__ARCHIVE:
          return hasPermissions('scenario:archive')

        case SCENARIO__DOWNLOAD_PDF:
          return hasPermissions('scenario:download-pdf')

        case SCENARIO__SEND_PDF:
          return hasPermissions('scenario:send-pdf')

        case SCENARIO__EXPORT_PROJECTIONS:
          return hasPermissions('scenario:export-projections')

        case ASSUMPTION__EDIT:
          return hasPermissions('assumption:edit')

        case ASSUMPTION__VIEW:
          return hasPermissions('assumption:view')

        case JOINT_PLAN__CREATE:
          return hasPermissions('joint-plan:create')

        case JOINT_PLAN__VIEW:
          return hasPermissions('joint-plan:view')

        case JOINT_PLAN__DELETE:
          return hasPermissions('joint-plan:delete')

        case JOINT_PLAN__EDIT:
          return hasPermissions('joint-plan:edit')

        case JOINT_PLAN__DOWNLOAD_PDF:
          return hasPermissions('joint-plan:download-pdf')

        case CUSTOMER_SUPPORT_TICKET__QUICK_REPORT_ISSUE:
          return hasPermissions('customer-support:quick-report-issue')

        case WEALTH_MANAGER_REQUEST__ALL:
          return hasPermissions('wealth-manager-request:all')

        case ASTUTE_CCP__ALL:
          return hasPermissions('astute-ccp:all')

        case FNA__ALL:
          return hasPermissions('fna:all')

        case CLIENT_PDF_REPORT__ALL:
          return hasPermissions('client-pdf-report:all')

        case CLIENT_LIABILITY__ALL:
          return hasPermissions('client-liability:all')

        case ASSET__AUTO_LINKING:
          return hasPermissions('asset:auto-linking')

        case ASSET_EVENT__ALL:
          return hasPermissions('asset-event:all')

        case NOTE__CREATE:
          return hasPermissions('note:create')

        case NOTE__EDIT:
          return hasPermissions('note:edit')

        case NOTE__VIEW_PRIVATE:
          return hasPermissions('note:view-private')

        case INVESTMENT_PROPOSAL__CREATE:
          return hasPermissions('investment-proposal:create')

        /* Feature toggle cases, acting like a legacy adapter to the feature
         * toggles that have been promoted from release toggles into features
         * but have yet to be migrated into permissions */
        case MOMENTUM_POC__ALL:
          return hasFeatureToggle('momentumPOC')

        case SCENARIO_IMPLEMENTED_PLAN_READ_ONLY__ALL:
          return hasFeatureToggle('implementedPlanReadOnly')

        default:
          throw new Error(`${featureName} not recognised in FeatureAccessProvider.`)
      }
    }
  }
}
